<template>
  <div>
    <div class="form-group">
      <bs-select
        label="Land"
        name="country"
        classname="form-control js-select2"
        :disabled="true"
        :options="
          Object.keys(countries)
            .filter((key) => countries[key])
            .map((key) => {
              return {
                name: countries[key],
                value: key,
              };
            })
            .sort((a, b) => {
              return a['name'] - b['name'];
            })
        "
        v-model="newUser.country"
      ></bs-select>
    </div>
    <p v-if="user.country != 'NL'">Uw bedrijf is gevestigd buiten Nederland. Wil je onderstaande gegevens aanpassen? Stuur dan een mail <a href="mailto:support@seotool.nl">support@seotool.nl</a></p>
    <div class="form-group">
      <bs-input label="Bedrijfsnaam" name="company" v-model="newUser.company" :disabled="user.country != 'NL'"></bs-input>
    </div>
    <div class="form-group">
      <bs-input label="KVK Nummer" name="coc" v-model="newUser.coc" :disabled="user.country != 'NL'"></bs-input>
    </div>
    <div class="form-group">
      <bs-input label="BTW Nummer" name="vat" v-model="newUser.vat" :disabled="user.country != 'NL'"></bs-input>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    countries: {
      type: Object,
      required: true,
    },
    errors: {
      required: true,
    },
  },
  data() {
    return {
      newUser: null,
    };
  },
  created() {
    this.newUser = this.user;
  },
};
</script>
